import { render } from "./NButtonModelCopy.vue?vue&type=template&id=1b4b9998&ts=true"
import script from "./NButtonModelCopy.vue?vue&type=script&lang=ts"
export * from "./NButtonModelCopy.vue?vue&type=script&lang=ts"

import "./NButtonModelCopy.vue?vue&type=style&index=0&id=1b4b9998&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__